import type { FeatureFlagKey, FeatureFlagValues } from '@prakash-software/shared';
import { apiFetch } from './api';

/** The caller's flags, evaluated by the server for their account. */
export const getFeatureFlags = () =>
  apiFetch<{ flags: FeatureFlagValues }>('/api/feature-flags').then((r) => r.flags);

// ─── Admin → Flags (super-admin) ───

export interface FlagOverrideRow {
  accountId: string;
  accountName: string;
  accountSlug: string;
  enabled: boolean;
  updatedAt: string;
}

export interface FlagAdminRow {
  key: FeatureFlagKey;
  description: string;
  defaultEnabled: boolean;
  /** null = never edited, at its catalog default. */
  stored: { enabled: boolean; rolloutPercent: number; updatedAt: string } | null;
  overrides: FlagOverrideRow[];
}

const base = '/api/admin/feature-flags';

export const listFlagsAdmin = () => apiFetch<{ flags: FlagAdminRow[] }>(base).then((r) => r.flags);

export const updateFlag = (key: FeatureFlagKey, patch: { enabled?: boolean; rolloutPercent?: number }) =>
  apiFetch<{ ok: true }>(`${base}/${key}`, { method: 'PATCH', body: JSON.stringify(patch) });

export const resetFlag = (key: FeatureFlagKey) => apiFetch<{ ok: true }>(`${base}/${key}`, { method: 'DELETE' });

export const setFlagOverride = (key: FeatureFlagKey, accountId: string, enabled: boolean) =>
  apiFetch<{ ok: true }>(`${base}/${key}/overrides/${accountId}`, {
    method: 'PUT',
    body: JSON.stringify({ enabled }),
  });

export const clearFlagOverride = (key: FeatureFlagKey, accountId: string) =>
  apiFetch<{ ok: true }>(`${base}/${key}/overrides/${accountId}`, { method: 'DELETE' });
